import { render, staticRenderFns } from "./TwoFactorVerificationStep.vue?vue&type=template&id=1215c4be"
import script from "./TwoFactorVerificationStep.vue?vue&type=script&lang=js"
export * from "./TwoFactorVerificationStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports